<template>
    <div class="mt-5 bg-white mx-4 " style="min-height: 350px;">

        <div class="mt-5 card">
            <div class="card-header text-primary">Create Items</div>

            <div class="row justify-content-center px-3">
                <div class="card-body col-md-10 col-sm-9 mt-3">
                    <form action="#" @submit.prevent>
                        <div class="row">
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label><span class="text-danger">*</span> Item Name</label>
                                <input class="form-control" type="text" placeholder="Enter Item name" v-model.trim="$v.formInfo.itemName.$model"  :class="{'is-invalid':$v.formInfo.itemName.$error, 'is-valid':!$v.formInfo.itemName.$invalid}">
                            </div>
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label for="percentageWht"><span class="text-danger">*</span> Percentage WHT</label>
                                <div class="input-group">
                                    <input class="form-control" type="number"  placeholder="Enter WHT Percentage" v-model.number="$v.formInfo.percentageWht.$model"  :class="{'is-invalid':$v.formInfo.percentageWht.$error, 'is-valid':!$v.formInfo.percentageWht.$invalid}">
                                    <div class="input-group-prepend">
                                        <b class="input-group-text" id="addon-wrapping" style="font-size:13px;">%</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="d-flex justify-content-end mt-4">
                            <button class="btn btn-primary btn-sm" @click="addRow()">
                                Add field
                                <!-- <v-icon name="plus"></v-icon> -->
                            </button>
                        </div>
                        <table style="width:100%" class="table table-borderless">
                            <thead>
                                <tr class="border-bottom">
                                    <th scope="col">#</th>
                                    <th scope="col">Field Name</th>
                                    <th scope="col">Variable Name</th>
                                    <th scope="col">Options</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="" v-for="(field, index) in fields" :key="index">
                                    <td>
                                        <button class="btn btn-danger btn-sm" @click="removeRow(index)">
                                            <v-icon name="trash-2"></v-icon>
                                        </button>
                                    </td>
                                    <td class="form-row">
                                        <div class="col-1 text-danger pr-0 d-flex justify-content-center">*</div>
                                        <div class="col-11 pl-0">
                                            <input class="form-control" v-model="field.fieldName" type="text" placeholder="Enter field name">
                                        </div>
                                    </td>
                                    <td class="">
                                        <div class="form-row">
                                            <div class="col-md-1 text-danger pr-0 d-flex justify-content-center">*</div>
                                            <div class="col-md-11 pl-0">
                                                <input class="form-control" v-model="field.variableName" type="text" placeholder="Enter variable name">
                                                <small class="text-info">&#9432; Camel case is advised and No space</small>
                                            </div>  
                                        </div>
                                    </td>
                                    <td class="form-group">  
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" :checked="field.upload" type="checkbox" :id="'choice'+index" v-model="field.upload">
                                            <label class="form-check-label" :for="'choice'+index">Upload Required Field</label>
                                        </div><br>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" :checked="field.creditnote" type="checkbox" :id="'choice'+index" v-model="field.creditnote">
                                            <label class="form-check-label" :for="'choice'+index">Creditnote Required Field</label>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    
                        <div class="form-group mb-3 mt-4 text-center">
                            <button class="btn btn-primary btn-sm" :disabled="$v.formInfo.$invalid"  @click.prevent="previewItem()"> 
                                Preview Item 
                                <div v-if="previewing" class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </button>
                        </div>
                    </form>

                    <!-- Preview Section -->
                    <section v-if="showPreview">
                        <hr class="mt-5">
                        <h3><u>Item Details</u></h3>
                        <p class="text-danger">{{ message }}</p>
                        <!-- Preview div -->
                        <div class="">
                            <div class="row d-flex justify-content-between">
                                <div class="col-md-5">
                                    <p>Item Name: <b>{{formInfo.itemName}}</b></p>
                                </div>
                                <div class="col-md-5">
                                    <p>Item Percentage for WHT: <b>{{formInfo.percentageWht}}</b></p>
                                </div>
                            </div>

                            <div class="row d-flex justify-content-between">
                                <div class="col-md-4">
                                    <p class="mb-1"><u>Upload Required fields</u></p>
                                    <ul>
                                        <li v-for="(field, index) in requiredFields" :key="index">{{field}}</li>
                                    </ul>
                                </div>
                                <div class="col-md-4">
                                    <p class="mb-1"><u>Credit-note Required fields</u></p>
                                    <ul>
                                        <li v-for="(field, index) in clientRequiredFields" :key="index">{{field}}</li>
                                    </ul>
                                </div>
                                <div class="col-md-4">
                                    <p class="mb-1"><u>Excel Column Names</u></p>
                                    <ul>
                                        <li v-for="(field, index) in Object.values(uploadRequiredFields)" :key="index">{{field}}</li>
                                    </ul>
                                </div>
                            </div>

                            <!-- <div>
                                <p><u>Excel </u></p>
                                <table class="table" v-if="Object.keys(uploadRequiredFields).length">
                                    <thead>
                                        <tr>
                                            <th>Field Name</th>
                                            <th>Variable Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(value, name) in Object.values(uploadRequiredFields)">
                                            <td>{{ value }}</td>
                                            <td>{{ name }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> -->
                        </div>

                        <div class="form-group mb-3 mt-4 text-center">
                            <button class="btn btn-primary btn-sm" :disabled="!createItemStatus" @click.prevent="createItem()"> 
                                Create Item 
                                <div v-if="sending" class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </button>
                        </div>
                    </section>
                </div>
            </div> <!-- end col -->
        </div>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'CreateAgent',
    data() {
        return {
            message: null,
            formInfo: {
                itemName: null,
                percentageWht: null
            },
            fields: [
                {
                    fieldName: null,
                    variableName: null,
                    upload: false,
                    creditnote: false
                },
                {
                    fieldName: null,
                    variableName: null,
                    upload: false,
                    creditnote: false
                }
            ],
            requiredFields: [],
            clientRequiredFields: [],
            uploadRequiredFields: {},
            sending: false,
            previewing: false,
            createItemStatus: false,
            showPreview: false,
            success: false,
        };
    },
    validations: {
        formInfo: {
            itemName: { required },
            percentageWht:{ required },
        }
    },

    computed:{
        ...mapState(['token']),
        ...mapGetters(['everyStates'])
    },

    methods:{
        removeRow(row) {
            console.log(row);
            this.fields.splice(row, 1)
        },

        addRow() {
            this.fields.push(
                {
                    fieldName: null,
                    variableName: null,
                    upload: false,
                    creditnote: false
                }
            )
        },

        previewItem() {
            this.previewing = true;
            this.clientRequiredFields = [];
            this.requiredFields = [];
            this.uploadRequiredFields = [];

            // build the arrays
            this.fields.forEach(field => {
                if (!field.variableName || !field.fieldName) {
                    return ;
                }
                const variableName = (field.variableName).trim().replace(/\s/g, '');
                // Add to excel build
                this.uploadRequiredFields[variableName] = field.fieldName;

                // add fields for credit note
                if (field.creditnote) {
                    this.clientRequiredFields.push(variableName);
                } 
                // add compulsory upload fields   
                if (field.upload) {
                    this.requiredFields.push(variableName);
                }
            });

            console.log(this.clientRequiredFields)
            console.log(this.requiredFields)
            console.log(Object.keys(this.uploadRequiredFields).length)

            if (!Object.keys(this.uploadRequiredFields).length || !this.requiredFields.length || !this.clientRequiredFields.length) {
                this.createItemStatus = false;
                this.message = "Item cannot be created with no field!!!";
            }else{
                this.createItemStatus = true;
            }

            this.showPreview = true;
            this.previewing = false;
        },

        createItem(){
            this.sending = true;

            // Only send after validations
            this.$v.formInfo.$touch()
            if (this.$v.formInfo.$invalid || this.$v.formInfo.$error) {
                // show errors
            } else {
                // submit logic
                const baseU = `${this.$urlUpload}/item`;

                // this.$http.post(baseU, {
                //     itemName: this.formInfo.itemName,
                //     percentageWht: this.formInfo.percentageWht,
                //     requiredFields: this.requiredFields,
                //     clientRequiredFields: this.clientRequiredFields,
                //     uploadRequiredFields: this.uploadRequiredFields,
                // }, {
                //     headers:{
                //         "x-access-token":this.token
                //     }
                // })
                // .then((result) => {
                //     if(result.data.data.code == "S201"){
                //         console.log(result.data.data.message)
                //         this.$toastr.s("Account Created Succesfully");

                //         this.sending = false;
                //     }else {
                //         this.$toastr.e(result.data.data.message);
                //         this.sending = false;
                //     }
                // }).catch(err =>{
                //     this.$toastr.e("Cannot connect to serve. Check your internet connection");
                //     this.sending = false;
                // })
            }
        }
    }
}

</script>
<style scoped>
    .icon {
        width: 15px;
        color: #fff;
    }
</style>